import clsx from 'clsx';
import { Alert } from 'antd';
import { useLocalStorage } from 'react-use';
import { IOpInfoProps } from '../OpInfo';

import '../OpInfo.scss';

interface IOpInfoWithDismissProps extends Omit<IOpInfoProps, 'dismissibleId'> {
  dismissibleId: string;
}

export const OpInfoWithDismiss = ({
  className,
  dismissibleId,
  ...alertProps
}: IOpInfoWithDismissProps) => {
  /** Using the useLocalStorage hook in order to allow for the Tipbox to be hidden */
  const [isVisible, setIsVisible] = useLocalStorage(dismissibleId, true);

  if (!isVisible) {
    return null;
  }

  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    <Alert
      className={clsx('op-info', className)}
      showIcon
      {...alertProps}
      closable
      onClose={handleClose}
    />
  );
};
